import React from 'react'
import styled from 'styled-components'
import { gray } from 'sutra/tokens/colors'
import { spacing } from 'sutra/tokens/spacing'

import { PostIcons } from 'components/post-overview/PostIcons'
import type { PostDetails } from 'types/project'

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]}px;
  margin-top: ${spacing[2]}px;
`

// Plain DOM primitive, not styled(Text) — see PostDetailsSection.tsx's
// TEXT_SM comment for why wrapping Text with styled() is a footgun the
// moment `as` gets involved.
const SourceLabel = styled.div`
  flex: 1;
  text-align: left;
  font-family: 'Poppins', system-ui, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${gray[500]};
`

export const SourceAndIcons: React.FC<{
  post?: PostDetails
  onPromoHover: (isHover: boolean) => void
  trailingAction?: React.ReactNode
  // Caller-supplied — this shared component doesn't read feature flags
  // itself; the caller resolves `show_record_usernames` and passes it down.
  showUsername?: boolean
}> = ({ post, onPromoHover, trailingAction, showUsername }) => {
  if (!post) return null
  return (
    <Row>
      <SourceLabel>
        {post.source_type}
        {showUsername && ` · ${post.username}`}
      </SourceLabel>
      <PostIcons
        is_promoted={post.is_promoted}
        is_recommended={post.is_recommended}
        is_verified={post.is_verified}
        n_instances={post?.n_instances}
        onPromoHover={onPromoHover}
      />
      {trailingAction}
    </Row>
  )
}
